import React, { useState, useEffect, Dispatch, SetStateAction } from 'react';
import { MetricDataResults } from 'aws-sdk/clients/cloudwatch';
import Graph from './Graph';
import moment from 'moment';
import Select from 'antd/lib/select';
import DatePicker from '../common/datePicker';
import { Col, Row } from 'antd/lib/grid';
import { Typography } from 'antd';

const { Option } = Select;

interface Props {
  data: MetricDataResults;
  dateRange: [moment.Moment, moment.Moment];
  setDateRange: Dispatch<SetStateAction<[moment.Moment, moment.Moment]>>;
  detail: number;
  setDetail: Dispatch<SetStateAction<number>>;
}

const Insights = ({
  data,
  dateRange,
  setDateRange,
  detail,
  setDetail
}: Props): JSX.Element => {
  const [categorizedData, setCategorizedData] =
    useState<Record<string, MetricDataResults>>();

  useEffect(() => {
    // categorize the datasets (each dataset is a line on the graph, we want them separate on multiple graphs)
    const categorizedDatasets: Record<string, MetricDataResults> = {};
    data.forEach((dataset) => {
      if (dataset.Label) {
        const key = dataset.Label.substring(dataset.Label.lastIndexOf('-') + 1); // e.g. "{dimension} {envId}-byStatus" => "byStatus"
        if (!categorizedDatasets[key]) {
          categorizedDatasets[key] = [];
        }
        categorizedDatasets[key].push(dataset);
      }
    });
    console.log(categorizedDatasets);
    setCategorizedData(categorizedDatasets);
  }, [data]);

  return (
    <div style={{ padding: '24px' }}>
      <Row align="middle">
        <Col style={{ minWidth: '90px' }}>
          <Typography.Text>Date Range: </Typography.Text>
        </Col>
        <Col>
          <DatePicker.RangePicker
            style={{ width: '300px' }}
            allowEmpty={[false, false]}
            defaultValue={dateRange}
            ranges={{
              '1 Day': [moment().subtract(1, 'day'), moment()],
              '7 Days': [moment().subtract(7, 'days'), moment()],
              '30 Days': [moment().subtract(30, 'days'), moment()],
              '90 Days': [moment().subtract(90, 'days'), moment()]
            }}
            disabledDate={(current) => {
              // Can not select before 7 days ago
              return (
                current && current < moment().add(-3, 'months').startOf('day')
              );
            }}
            onCalendarChange={(values, format, info) => {
              // when user is done selecting the end range, submit the filter for ease of use
              if (info.range === 'end' && values && values[0] && values[1]) {
                setDateRange([values[0], values[1]]);
              }
            }}
          />
        </Col>
      </Row>
      <Row align="middle" style={{ marginTop: '12px', marginBottom: '20px' }}>
        <Col style={{ minWidth: '90px' }}>
          <Typography.Text>Detail: </Typography.Text>
        </Col>
        <Col>
          <Select
            style={{ width: '300px' }}
            defaultValue="86400"
            onChange={(value: string) => {
              setDetail(Number.parseInt(value));
            }}
          >
            <Option value="86400">Daily</Option>
            <Option value="604800">Weekly</Option>
            <Option value="2592000">30 Days</Option>
          </Select>
        </Col>
      </Row>
      {categorizedData &&
        Object.keys(categorizedData).map((id) => {
          return (
            <Graph
              id={id}
              data={categorizedData[id]}
              dateRange={dateRange}
              key={id}
              detail={detail}
            />
          );
        })}
    </div>
  );
};

export default Insights;
